import { useState } from 'react';
import styles from './DistanceComponent.module.scss';
import { Icon } from '../Icon';
import { useAppDispatch, useAppSelector } from 'app/store/store';
import { setPortsForDistanceCalc } from 'app/utils/searchSlice';
import _ from 'lodash';
import { SelectedPort } from './SelectedPort';

import { DistancePortSelect } from './DistancePortSelect';

interface TermI {
  from: string;
  to: string;
}
export interface SearchStateI {
  term: TermI;
  visibility: {
    from: boolean;
    to: boolean;
  };
}
/**
 * LIMIT - количество возвращаемых строк от BE. Max - 1000
 */
const LIMIT = 1000;

export const DistanceComponent = () => {
  const dispatch = useAppDispatch();

  const storeDistanceData = useAppSelector((state) => state.searchSlice.distanceBetween);

  const [searchState, setSearchState] = useState<SearchStateI>({
    term: {
      from: '',
      to: '',
    },
    visibility: {
      from: false,
      to: false,
    },
  });

  const swapPorts = () => {
    const from = storeDistanceData.from;
    const to = storeDistanceData.to;
    setSearchState((prevState: SearchStateI) => ({
      term: {
        from: prevState.term.to,
        to: prevState.term.from,
      },
      visibility: {
        ...prevState.visibility,
      },
    }));
    dispatch(setPortsForDistanceCalc({ ...storeDistanceData, from: to, to: from }));
  };

  return (
    <div className={styles.root}>
      <div
        className={styles.indicator}
        data-selected={Object.keys(storeDistanceData.from).length !== 0 && Object.keys(storeDistanceData.to).length !== 0}
      >
        <div className={styles.circle} />
        <div className={styles.line} />
        <div className={styles.circle} />
      </div>
      <div className={styles.input_group}>
        <div className={styles.group_item} data-result={true}>
          <DistancePortSelect fieldName="from" />

          <SelectedPort port={storeDistanceData.from} />
        </div>
        <div className={styles.swap}>
          <div className={styles.divider} />
          <div
            className={styles.swap_button}
            onClick={() => swapPorts()}
            data-selected={!_.isEmpty(storeDistanceData.from) && !_.isEmpty(storeDistanceData.to)}
          >
            <Icon name="swap" size="24" />
          </div>
          <div className={styles.divider} />
        </div>
        <div className={styles.group_item} data-result={true}>
          <DistancePortSelect fieldName="to" />

          <SelectedPort port={storeDistanceData.to} />
        </div>
      </div>
    </div>
  );
};
